
import BotonWhatsapp from "../components/BotonWhatsapp";

function Nosotros() {
  return (
    <div>
      
      
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20 mt-16">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl font-bold mb-6">
            Sobre Betalink
          </h1>
          <p className="text-xl mb-8">
            Tu empresa local de internet en Pujilí
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-8 text-gray-800">
              Internet de Calidad en Pujilí
            </h2>
            
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div className="text-left">
                <h3 className="text-2xl font-bold mb-4 text-blue-600">Nuestra Misión</h3>
                <p className="text-lg text-gray-600 mb-6">
                  Brindar internet de alta velocidad a las familias y empresas de Pujilí 
                  con precios justos, instalación gratuita y soporte técnico local.
                </p>
                <ul className="space-y-2">
                  <li className="flex items-center">
                    <span className="text-green-500 mr-2">✓</span>
                    Empresa local de Pujilí
                  </li>
                  <li className="flex items-center">
                    <span className="text-green-500 mr-2">✓</span>
                    Técnicos especializados
                  </li>
                  <li className="flex items-center">
                    <span className="text-green-500 mr-2">✓</span>
                    Atención personalizada
                  </li>
                  <li className="flex items-center">
                    <span className="text-green-500 mr-2">✓</span>
                    Precios competitivos
                  </li>
                </ul>
              </div>
              
              <div className="bg-blue-50 rounded-lg p-8">
                <h3 className="text-xl font-bold mb-4">Contáctanos</h3>
                <div className="space-y-3">
                  <div className="flex items-center">
                    <span className="text-2xl mr-3">📍</span>
                    <div>
                      <div className="font-semibold">Dirección</div>
                      <div className="text-gray-600">Calle Pichincha y Zoila Victoria, Pujilí</div>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <span className="text-2xl mr-3">📞</span>
                    <div>
                      <div className="font-semibold">Teléfono</div>
                      <a href="tel:0998106377" className="text-blue-600">099 810 6377</a>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <span className="text-2xl mr-3">💬</span>
                    <div>
                      <div className="font-semibold">WhatsApp</div>
                      <a href="https://wa.me/593998106377" className="text-green-600">+593 99 810 6377</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BotonWhatsapp />
    </div>
  );
}

export default Nosotros;